export default {
  name: 'manage-discipline',
  label: 'Attendance',
  link: 'attendance',
  path: 'attendance',
  props: true,
  icon: 'hundred-points',
  description: 'View and edit worker attendance infractions and events.',
  component: () => import('@/components/TabPanel.vue'),
  requirePerm: 'manage_discipline',
  requireFeature: 'discipline',
  requireGetter: 'disciplineEnabled',
  breadcrumbLeaf: true,
  children: [
    {
      name: 'discipline-infractions',
      label: 'Infractions',
      title: 'Attendance Infractions',
      path: 'infractions/:view?',
      component: () => import('./DisciplineInfractionList.vue')
    },
    {
      name: 'discipline-events',
      label: 'Events',
      title: 'Attendance Events',
      path: 'events/:view?',
      component: () => import('./DisciplineEventList.vue')
    },
    {
      name: 'manage-discipline-index',
      path: '',
      redirect: { name: 'discipline-infractions' }
    }
  ]
}
